import './about.css';
import './feedback.css';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faCheckCircle } from "@fortawesome/free-solid-svg-icons";






export const Feedback = () => {
  const [formData, setFormData] = useState({
    email: '',
    subject: '',
    description: '',
    type: ''
  });
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('sending');
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ email: '', subject: '', description: '', type: '' });
        
        // Resetam mesajul de succes dupa 5 secunde
        setTimeout(() => setSubmitStatus(''), 5000);
      } else {
        setSubmitStatus('error');
        setTimeout(() => setSubmitStatus(''), 5000);
      }
    } catch (error) {
      console.error('Eroare trimitere feedback:', error);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(''), 5000);
    }
  };

  return (
  

    <div className="general-container-footer-info-ab">
      <div className="info-footer-container-ab">

   


        <div className='tittle-ab-top'>
            <h4>Cum te putem ajuta?</h4>
        </div>

        

       <section className='section-about-2'>
  <div className='part-left-feedback'>

 <h4>Descrie problema</h4>
  <p>
    Povesteste-ne pe scurt ce nu a functionat cum te asteptai.
    <br/>
    Cu cat avem mai multe detalii, cu atat putem ajuta mai repede.
    </p>
  </div>
  <div className='part-right-feedback'>
  <div className="feedback-form">
  
  {submitStatus === 'success' && (
    <div className='ajutor-success-box' style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#e8f5e9', border: '1px solid #4caf50', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '10px' }}>
      <FontAwesomeIcon icon={faCheckCircle} style={{ color: '#4caf50', fontSize: '24px' }} />
      <div>
        <strong style={{ color: '#2e7d32' }}>Feedback trimis cu succes!</strong>
        <p style={{ margin: 0, color: '#1b5e20', fontSize: '14px' }}>Iti multumim, mesajul a ajuns la noi.</p>
      </div>
    </div>
  )}

  {submitStatus === 'error' && (
    <div className='ajutor-success-box' style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fdecea', border: '1px solid #f44336', borderRadius: '8px' }}>
      <strong style={{ color: '#f44336' }}>Eroare la trimiterea feedback-ului.</strong>
      <p style={{ margin: 0, color: '#c62828', fontSize: '14px' }}>Te rugam sa incerci din nou mai tarziu.</p>
    </div>
  )}

  <form onSubmit={handleSubmit}>
    <label>
      Adresa de e-mail *
      <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="ex: exemplu@email.com" />
    </label>

    <label>
      Subiect *
      <input type="text" name="subject" value={formData.subject} onChange={handleChange} required />
    </label>

    <label>
      Descriere *
      <textarea name="description" value={formData.description} onChange={handleChange} required placeholder="Descrie cat mai clar problema..."></textarea>
    </label>

    <label>
      Tipul problemei *
      <select name="type" value={formData.type} onChange={handleChange} required>
        <option value="">Selecteaza unul...</option>
        <option value="raporteaza-abuz">Raporteaza abuz</option>
        <option value="acces-cont">Nu-mi pot accesa contul</option>
        <option value="eroare">Raport de eroare</option>
        <option value="achizitie">Problema cu achizitia sau abonamentul</option>
        <option value="alta-eroare">Alta eroare</option>
        <option value="stergere-cont">Solicitare de stergere a contului</option>
      </select>
    </label>



    <button type="submit" disabled={submitStatus === 'sending'} style={{ opacity: submitStatus === 'sending' ? 0.7 : 1 }}>
      {submitStatus === 'sending' ? 'Se trimite...' : 'Trimite'}
    </button>
  </form>
</div>

  
</div>

</section>


       














           
       








     

      </div>
    </div>
   
  )
}
